<div *ngIf="transactionForm" class="form-modal">
  <h1 mat-dialog-title>{{'TRANSITION'|translate}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="transactionForm" class="form-horizontal">
      <div class="form-group">

        <!-- Panel base -->
        <div [ngClass]="{'col-md-4' : showCreationPopup, 'col-md-6' : !showCreationPopup}">
          <div class="panel panel-default">
            <div class="panel-body no-horizontal-padding">
              <div class="form-group">
                <!-- Do Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{'FROM_STATE'|translate}}</mat-label>

                    <mat-select formControlName="FromStateID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.FromStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option>
                        <ngx-mat-select-search formControlName="FromStateIDFilter"
                          [placeholderLabel]="'SEARCH'|translate"
                          [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                          <i class="fas fa-times" ngxMatSelectSearchClear></i>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let state of filteredFromStateIDs | async" [value]="state.ID">{{state.Name ? state.Name : state.Description}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.FromStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.FromStateID">{{
                    formErrors.FromStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Para Estado -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth">
                    <mat-label>{{'TO_STATE'|translate}}</mat-label>
                    <mat-select formControlName="ToStateID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.ToStateID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option>
                        <ngx-mat-select-search formControlName="ToStateIDFilter"
                          [placeholderLabel]="'SEARCH'|translate"
                          [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                          <i class="fas fa-times" ngxMatSelectSearchClear></i>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let state of filteredToStateIDs | async" [value]="state.ID">{{state.Name ? state.Name : state.Description}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ToStateID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.ToStateID">{{
                    formErrors.ToStateID }}</mat-error>
                </div>
                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <!-- Ação -->
                <div class="col-md-12 col-sm-12">
                  <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.ActionVerb }">
                    <mat-label>{{ 'ACTION_NAME' | translate}}</mat-label>
                    <input matInput formControlName="ActionVerb">
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.ActionVerb" class="font75per" [translate]
                    [translateParams]="formErrorsParam.ActionVerb">{{
                    formErrors.ActionVerb }}</mat-error>
                </div>

                <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                <div class="col-md-12" style="padding-top: 8px;">
                  <div class="panel panel-default">
                    <div class="panel-body no-horizontal-padding">
                      <div class="form-group">
                        <div class="col-md-12 col-sm-12" style="border-bottom: 1px solid #d9d9d9;">
                          <h5 class="panel-title" style="padding-bottom: 8px;font-size: 14px">
                            <strong>{{'TOTAL_NET_AMOUNT'|translate}}</strong>
                          </h5>
                        </div>
                        <!-- Checkbox tem limite -->
                        <div class="col-md-12 col-sm-12" style="padding-top: 8px;">
                          <mat-checkbox class="allwidth" formControlName="HasLimit">{{ 'LIMIT_VALUE' | translate}}
                          </mat-checkbox>
                        </div>
                        <!-- Limite mínimo -->
                        <div class="col-md-12 col-sm-12">
                          <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.MinimumLimit }">
                            <mat-label>Desde (€)</mat-label>
                            <input matInput formControlName="MinimumLimit">
                          </mat-form-field>
                          <mat-error *ngIf="formErrors.MinimumLimit" class="font75per" [translate]
                            [translateParams]="formErrorsParam.MinimumLimit">{{
                            formErrors.MinimumLimit }}</mat-error>
                        </div>
                        <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                        <!-- Limite máximo -->
                        <div class="col-md-12 col-sm-12">
                          <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.MaximumLimit }">
                            <mat-label>Até (€)</mat-label>
                            <input matInput formControlName="MaximumLimit">
                          </mat-form-field>
                          <mat-error *ngIf="formErrors.MaximumLimit" class="font75per" [translate]
                            [translateParams]="formErrorsParam.MaximumLimit">{{
                            formErrors.MaximumLimit }}</mat-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" *ngIf="showExcessAmountFields">
                  <div class="panel panel-default">
                    <div class="panel-body no-horizontal-padding">
                      <div class="form-group">
                        <div class="col-md-12 col-sm-12" style="border-bottom: 1px solid #d9d9d9;">
                          <h5 class="panel-title" style="padding-bottom: 8px;font-size: 14px">
                            <strong>{{'EXCESS_AMOUNT'|translate}}</strong>
                          </h5>
                        </div>
                        <!-- Checkbox tem limite -->
                        <div class="col-md-12 col-sm-12" style="padding-top: 8px;">
                          <mat-checkbox class="allwidth" formControlName="ExcessAmountHasLimit">{{ 'LIMIT_VALUE' |
                            translate}}
                          </mat-checkbox>
                        </div>
                        <!-- Limite mínimo -->
                        <div class="col-md-12 col-sm-12">
                          <mat-form-field class="allwidth"
                            [ngClass]="{ 'mat-input-invalid': formErrors.ExcessAmountMinimumLimit }">
                            <mat-label>Desde (€)</mat-label>
                            <input matInput formControlName="ExcessAmountMinimumLimit">
                          </mat-form-field>
                          <mat-error *ngIf="formErrors.ExcessAmountMinimumLimit" class="font75per" [translate]
                            [translateParams]="formErrorsParam.ExcessAmountMinimumLimit">{{
                            formErrors.ExcessAmountMinimumLimit }}</mat-error>
                        </div>
                        <div class="col-md-12 col-xs-12 spacer-bottom-xs"></div>
                        <!-- Limite máximo -->
                        <div class="col-md-12 col-sm-12" *ngIf="showExcessAmountFields">
                          <mat-form-field class="allwidth"
                            [ngClass]="{ 'mat-input-invalid': formErrors.ExcessAmountMaximumLimit }">
                            <mat-label>Até (€)</mat-label>
                            <input matInput formControlName="ExcessAmountMaximumLimit">
                          </mat-form-field>
                          <mat-error *ngIf="formErrors.ExcessAmountMaximumLimit" class="font75per" [translate]
                            [translateParams]="formErrorsParam.ExcessAmountMaximumLimit">{{
                            formErrors.MaximumLimit }}</mat-error>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Centro de custo -->
                <div class="col-md-12 col-sm-12" *ngIf="!hideCostCenter && costCentersList">
                  <mat-form-field class="allwidth">
                    <mat-label>Centro de Custo</mat-label>

                    <mat-select formControlName="CostCenterID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.CostCenterID }">
                      <!--<mat-option value=''></mat-option>-->
                      <mat-option>
                        <ngx-mat-select-search formControlName="CostCenterIDFilter"
                          [placeholderLabel]="'SEARCH'|translate"
                          [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                          <i class="fas fa-times" ngxMatSelectSearchClear></i>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let costCenter of filteredCostCenters | async" [value]="costCenter.ID">{{costCenter.Name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.CostCenterID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.CostCenterID">{{
                    formErrors.CostCenterID }}</mat-error>
                </div>

                <!-- Grupo de Utilizador -->
                <div class="col-sm-12" *ngIf="userGroupsList && userGroupsList.length > 0">
                  <mat-form-field class="full-width">
                    <mat-label>{{ ('DEPARTMENT' | translate) }}</mat-label>
                    <mat-select
                      formControlName="UserGroupID">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let userGroup of userGroupsList" [value]="userGroup.ID">
                        {{userGroup.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.UserGroupID" class="field-validation-valid text-danger"
                  [translate] [translateParams]="formErrorsParam.UserGroupID">{{
                  formErrors.UserGroupID }}</span>
                </div>

                <!-- Auditoria (Despesas) -->
                <div class="col-sm-12" *ngIf="transactionForm.get('Audit')">
                  <mat-form-field class="full-width">
                    <mat-label>{{ ('AUDIT' | translate) }}</mat-label>
                    <mat-select
                      formControlName="Audit">
                      <mat-option></mat-option>
                      <mat-option [value]="false">
                        {{ 'NO' | translate }}
                      </mat-option>
                      <mat-option [value]="true">
                        {{ 'YES' | translate }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="formErrors.Audit" class="field-validation-valid text-danger"
                  [translate] [translateParams]="formErrorsParam.Audit">{{
                  formErrors.Audit }}</span>
                </div>

                <!-- Sub Tipo de Documento -->
                <div class="col-md-12 col-sm-12" *ngIf="subTypeList.length > 0">
                  <mat-form-field class="allwidth">
                    <mat-label>{{ 'DOCUMENT_SUBTYPE' | translate}}</mat-label>
                    <mat-select formControlName="InvoiceSubTypeID"
                      [ngClass]="{ 'mat-input-invalid': formErrors.InvoiceSubTypeID }">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let subType of subTypeList" [value]="subType.ID">{{subType.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-error *ngIf="formErrors.InvoiceSubTypeID" class="font75per" [translate]
                    [translateParams]="formErrorsParam.InvoiceSubTypeID">{{
                    formErrors.InvoiceSubTypeID }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel da Tabela de Utilizadores -->
        <div class="col-md-4" *ngIf="showCreationPopup">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
              (click)="collPnPopup1 = !collPnPopup1">
              <h5 class="panel-title">
                <i class="fas fa-users"></i>
                <strong> {{'CREATION'|translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
              </h5>
            </div>
            <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                (click)="collPnPopup2 = !collPnPopup2">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'PROFILES'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                </h5>
              </div>
              <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowUsersProfiles" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <mat-label>{{'FILTER'|translate}}</mat-label>
                          <input type="text" matInput class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>

              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup3"
                (click)="collPnPopup3 = !collPnPopup3">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'USERS'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup3, 'fa-caret-up': !collPnPopup3}"></i>
                </h5>
              </div>
              <div id="collPnPopup3" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowUsers" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <mat-label>{{'FILTER'|translate}}</mat-label>
                          <input type="text" matInput class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
              
            </div>
          </div>
        </div>

        <!-- Panel da Tabela de Aprovadores -->
        <div [ngClass]="{'col-md-4' : showCreationPopup, 'col-md-6' : !showCreationPopup}">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup4"
              (click)="collPnPopup4 = !collPnPopup4">
              <h5 class="panel-title">
                <i class="fas fa-users"></i>
                <strong> {{'APPROVATION'|translate}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnPopup4, 'fa-caret-up': !collPnPopup4}"></i>
              </h5>
            </div>
            <div id="collPnPopup4" class="panel-body no-horizontal-padding collapse in">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup5"
                (click)="collPnPopup5 = !collPnPopup5">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'PROFILES'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup5, 'fa-caret-up': !collPnPopup5}"></i>
                </h5>
              </div>
              <div id="collPnPopup5" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowApproversProfiles" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <mat-label>{{'FILTER'|translate}}</mat-label>
                          <input type="text" matInput class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>

              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup6"
                (click)="collPnPopup6 = !collPnPopup6">
                <h5 class="panel-title">
                  <i class="fas fa-users"></i>
                  <strong> {{'USERS'|translate}}</strong>
                  <i class="collapse-icon fas"
                    [ngClass]="{'fa-caret-down': collPnPopup6, 'fa-caret-up': !collPnPopup6}"></i>
                </h5>
              </div>
              <div id="collPnPopup6" class="panel-body no-horizontal-padding collapse in">
                <table id="tabelaWorkflowApprovers" class="table table-bordered display" cellspacing="0">
                  <thead>
                    <tr>
                      <th>
                        <strong>{{ 'NAME'| translate}}</strong>
                      </th>
                      <th></th>
                    </tr>
                    <tr>
                      <th>
                        <mat-form-field class="full-width findInputContainer">
                          <mat-label>{{'FILTER'|translate}}</mat-label>
                          <input type="text" matInput class="findInput">
                        </mat-form-field>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!transactionForm.valid">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>